import { cn } from '@/shared/lib'

// Фирменные логотипы STIT из public/brand (белые по прозрачному — фирстиль
// тёмный by design). img, не inline-SVG: файлы приходят от бренда как есть.

export function BrandLogo({ className }: { className?: string }) {
  return <img src="/brand/stit.svg" alt="STIT" className={cn('w-auto select-none', className)} />
}

export function EcosystemsLogo({ className }: { className?: string }) {
  return (
    <img
      src="/brand/stit-ecosystems.svg"
      alt="STIT — разработка эко-систем"
      className={cn('w-auto select-none', className)}
    />
  )
}

// Официальный знак Authentik (simple-icons), для кнопки OIDC-входа.
export function AuthentikMark({ size = 18, className }: { size?: number; className?: string }) {
  return (
    <svg
      role="img"
      aria-label="Authentik"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="currentColor"
      className={className}
    >
      <path d="M13.96 9.01h-.84V7.492h-1.234v3.663H5.722c.34.517.538.982.538 1.152 0 .46-1.445 3.059-3.197 3.059C.8 15.427-.745 12.8.372 10.855a3.062 3.062 0 0 1 2.691-1.606c1.04 0 1.971.915 2.557 1.755V6.577a3.773 3.773 0 0 1 3.77-3.769h10.84C22.31 2.808 24 4.5 24 6.577v10.845a3.773 3.773 0 0 1-3.77 3.769h-1.6V17.5h-7.64v3.692h-1.6a3.773 3.773 0 0 1-3.77-3.769v-3.41h12.114v-6.52h-1.59v.893h-.84v-.893H13.96v1.516Zm-9.956 1.845c-.662-.703-1.578-.544-2.209 0-2.105 2.054 1.338 5.553 3.302 1.447a5.395 5.395 0 0 0-1.093-1.447Z" />
    </svg>
  )
}
